"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var uniq_1 = __importDefault(require("lodash/uniq"));
var arrayValidations = {
    length: function (array) { return array.length; },
    containsAny: function (arr1, arr2) {
        if (!arr1 || !arr2) {
            return false;
        }
        return (typeof arr1 === 'string' ? arr1.split('') : arr1).some(function (r) { return arr2.indexOf(r) >= 0; });
    },
    concatAll: function () {
        var arrays = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arrays[_i] = arguments[_i];
        }
        return arrays.reduce(function (prev, curr) {
            return prev.concat(curr);
        }, []);
    },
    uniq: uniq_1.default,
};
exports.default = arrayValidations;
//# sourceMappingURL=arrayValidations.js.map